module.exports = __webpack_public_path__ + "static/media/video-1.f8cf9316.jpg";